import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormulaireSelectionProjetParent from '../Ajouter/FormulaireSelectionProjetParent/FormulaireSelectionProjetParent';
import FormulaireAjoutUtilisateursAProjet from '../Ajouter/FormulaireAjoutUtilisateursAProjet/FormulaireAjoutUtilisateursAProjet';
import AjouterImageProjet from './AjouterImageProjet/AjouterImageProjet';
import AffichageImage from '../../UI/AffichageImage/AffichageImage';
import Bouton from '../../UI/Bouton/Bouton';
import AccesRestreins from '../../../hoc/AccesRestreins/AccesRestreins';
import AttenteRequete from '../../../hoc/AttenteRequete/AttenteRequete';
import Collapse from '../../../hoc/Collapse/Collapse';
import { stringOrEmptyString } from '../../../ressources/functionJS/stringOrEmptyString';
import * as privilege from '../../../ressources/glossaires/glossaire_privileges';
import { IsArrayString } from '../../../ressources/functionJS/IsArrayString';
import * as requestType from '../../../ressources/glossaires/glossaire_requetes';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import * as type_btn from '../../../ressources/glossaires/glossaire_type_de_bouton';
import { confirmeOnClick } from '../../../ressources/functionJS/confirmeOnClick';
import * as actions from '../../../services/actions';
import * as s from '../../../ressources/StyleGlobal/StyleGlobal';
import {
  AiFillPicture,
  AiFillEdit,
  AiFillDelete,
  AiOutlineClose,
  AiOutlineCheck,
} from 'react-icons/ai';
import styles from './ProfilProjet.module.scss';
import PopupSmall from '../../UI/PopupSmall/PopupSmall';

const ProfilProjet = ({ infoProjet, reqModifier, reqSupprimer }) => {
  const dispatch = useDispatch();

  // Redux selectors
  const listeUtilisateurs = useSelector(
    (state) => state.utilisateur.utilisateursListe
  );

  // Split state into multiple useState hooks
  const [projectId, setProjectId] = useState(infoProjet.project_id);
  const [projectName, setProjectName] = useState(infoProjet.project_name);
  const [parentId, setParentId] = useState(infoProjet.parent_id);
  const [geoBarr, setGeoBarr] = useState(
    infoProjet.geo_barr === null ? '[]' : infoProjet.geo_barr.toString()
  );
  const [groupe, setGroupe] = useState(infoProjet.groupe);
  const [usersListId, setUsersListId] = useState(infoProjet.users_list_id);
  const [description, setDescription] = useState(infoProjet.description);
  const [active, setActive] = useState(infoProjet.active);
  const [projectImage, setProjectImage] = useState(infoProjet.project_image);
  const [showModify, setShowModify] = useState(false);

  // Effect to sync with infoProjet changes
  useEffect(() => {
    setProjectId(infoProjet.project_id);
    setProjectName(infoProjet.project_name);
    setParentId(infoProjet.parent_id);
    setGeoBarr(
      infoProjet.geo_barr === null ? '[]' : infoProjet.geo_barr.toString()
    );
    setGroupe(infoProjet.groupe);
    setUsersListId(infoProjet.users_list_id);
    setDescription(infoProjet.description);
    setActive(infoProjet.active);
    setProjectImage(infoProjet.project_image);
    setShowModify(false);
  }, [infoProjet]);

  // Effect for initial data fetch
  useEffect(() => {
    dispatch(actions.reqRecupererListeUtilisateurs());
  }, [dispatch]);

  // Event handlers
  const handleParentId = (parentId) => {
    setParentId(parentId);
  };

  const handleUsersList = (usersList) => {
    setUsersListId(usersList);
  };

  const handleModify = () => {
    const modifiedProject = {
      project_id: parseInt(projectId),
      project_name: stringOrEmptyString(projectName),
      parent_id: parseInt(parentId),
      geo_barr: IsArrayString(geoBarr, []),
      groupe: stringOrEmptyString(groupe),
      users_list_id: usersListId,
      description: stringOrEmptyString(description),
      active: parseInt(active),
    };
    reqModifier(modifiedProject);
    setShowModify(false);
  };

  // Helper function to get users emails
  const getUserEmails = () => {
    const emails = [];
    if (usersListId && listeUtilisateurs) {
      usersListId.forEach((userId) => {
        const user = listeUtilisateurs.find((u) => u.user_id === userId);
        if (user) emails.push(user.email);
      });
    }
    return emails;
  };

  const emails_users_liste = getUserEmails();

  // Render helpers
  const renderModifyForm = () => (
    <>
      <div className={[styles.ConteneurInfo].join(' ')}>
        <div className={s.row}>
          <div className={[s.col_md_12, s.text_left].join(' ')}>
            <Collapse expandText={checkMot('modifier_info_general')}>
              <div className={s.row}>
                <div className={s.col_6}>
                  <label className={[styles.taglabel].join(' ')}>
                    {checkMot('nom')}{' '}
                  </label>
                  <input
                    onChange={(e) => setProjectName(e.target.value)}
                    name="info_text_project_name"
                    className={styles.text_master_b}
                    placeholder={projectName}
                    value={projectName}
                  />
                </div>
                <div className={s.col_6}>
                  <label className={[styles.taglabel].join(' ')}>
                    {checkMot('groupe')}
                  </label>
                  <input
                    onChange={(e) => setGroupe(e.target.value)}
                    name="info_text_groupe"
                    className={styles.text_master_b}
                    placeholder={groupe}
                    value={groupe}
                  />
                </div>
                <div className={s.col_12}>
                  <label className={[styles.taglabel].join(' ')}>
                    {checkMot('description')}
                  </label>
                  <input
                    onChange={(e) => setDescription(e.target.value)}
                    name="info_text_description"
                    className={styles.text_master_e}
                    placeholder={description}
                    value={description}
                  />
                </div>
                <div className={s.col_12}>
                  <FormulaireSelectionProjetParent
                    gererProjetParentId={handleParentId}
                    preconfigurerParentId={infoProjet.parent_id}
                    projet_id={infoProjet.project_id}
                  />
                </div>
                <div className={s.col_12}>
                  <label className={[styles.taglabel].join(' ')}>
                    {checkMot('liste_utilisateurs')}{' '}
                  </label>
                  <div className={styles.text_master_b}>
                    {emails_users_liste.map((email, index) => (
                      <p key={index}>{email}</p>
                    ))}
                  </div>
                </div>
              </div>
            </Collapse>
            <Collapse expandText={checkMot('modifier_info_avance')}>
              <div className={s.row}>
                <div className={s.col_12}>
                  <FormulaireAjoutUtilisateursAProjet
                    gererUtilisateursList={handleUsersList}
                    preconfigurerUtilisateursListId={infoProjet.users_list_id}
                  />
                </div>
                <div className={s.col_12}>
                  <label className={[styles.taglabel].join(' ')}>
                    {checkMot('image_de_projet_url')}
                  </label>
                  <input
                    onChange={(e) => setProjectImage(e.target.value)}
                    name="info_text_project_image"
                    className={styles.text_master_e}
                    placeholder={projectImage}
                    value={projectImage}
                  />
                </div>
                <div className={s.col_12}>
                  <label className={[styles.taglabel].join(' ')}>
                    {checkMot('etat')}
                  </label>
                  <select
                    value={active}
                    onChange={(e) => setActive(parseInt(e.target.value))}
                    name="info_text_active"
                    className={[s.custom_select, s.mr_sm_2].join(' ')}
                  >
                    <option value={1}>{checkMot('active')}</option>
                    <option value={0}>{checkMot('desactive')}</option>
                  </select>
                </div>
                <div className={s.col_12}>
                  <label className={[styles.taglabel].join(' ')}>
                    {checkMot('geo_barriere')}
                  </label>
                  <input
                    onChange={(e) => setGeoBarr(e.target.value)}
                    name="info_text_geo_barr"
                    className={styles.text_master_e}
                    placeholder={geoBarr}
                    value={geoBarr}
                  />
                </div>
              </div>
            </Collapse>
          </div>
        </div>
        <div className={s.row}>
          <div className={s.col_6}>
            <Bouton
              cliquer={() => setShowModify(false)}
              ajoutClass={styles.bts}
              type={type_btn.danger}
            >
              <AiOutlineClose /> {checkMot('annuler')}
            </Bouton>
          </div>
          <div className={[s.col_6, s.text_left].join('')}>
            <AttenteRequete request_type={requestType.modification_d_un_projet}>
              <Bouton
                cliquer={handleModify}
                ajoutClass={styles.bts}
                type={type_btn.succes}
              >
                <AiOutlineCheck /> {checkMot('enregistre')}
              </Bouton>
            </AttenteRequete>
          </div>
        </div>
      </div>
    </>
  );

  const renderProfile = () => (
    <>
      <div className={s.row}>
        <div className={[s.col_md_12, s.text_left].join(' ')}>
          <div className={[styles.imgProject, s.text_center].join(' ')}>
            {' '}
            {infoProjet.project_image !== null ? (
              <AffichageImage
                ajoutClass={styles.afficheImage}
                src={infoProjet.project_image}
                alt={'project_image'}
              />
            ) : (
              <div>aucune image de projet</div>
            )}
          </div>
          <Collapse expandText={checkMot('info_general')}>
            <div className={s.row}>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {checkMot('nom')}
                </label>
                <div className={styles.text_master}>
                  {infoProjet.project_name}
                </div>
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {checkMot('groupe')}
                </label>
                <div className={styles.text_master}>{infoProjet.groupe}</div>
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {checkMot('description')}
                </label>
                <div className={styles.text_master_d}>
                  {infoProjet.description}
                </div>
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {checkMot('id_du_projet_parent')}
                </label>
                <div className={styles.text_master}>
                  {infoProjet.parent_id !== null
                    ? infoProjet.parent_id
                    : 'Projet Principal'}
                </div>
              </div>
            </div>
          </Collapse>
          <Collapse expandText={checkMot('info_avance')}>
            <div className={s.row}>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {checkMot('image_de_projet_url')}
                </label>
                <div className={styles.text_master}>
                  {infoProjet.project_image}
                </div>
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {checkMot('etat')}
                </label>
                <div className={styles.text_master}>
                  {infoProjet.active ? 'Active' : 'Desactive'}
                </div>
              </div>
              <div className={s.col_12}>
                <label className={[styles.taglabel].join(' ')}>
                  {checkMot('geo_barriere')}
                </label>
                <div className={styles.text_master_d}>
                  {infoProjet.geo_barr === null
                    ? '[]'
                    : infoProjet.geo_barr.toString()}
                </div>
              </div>
              <div className={s.col_12}>
                <label className={[styles.taglabel].join(' ')}>
                  {checkMot('liste_utilisateurs')}
                </label>
                <div className={styles.text_master_d}>
                  {emails_users_liste.map((email, index) => (
                    <p key={index}>{email}</p>
                  ))}
                </div>
              </div>
            </div>
          </Collapse>
          <div className={s.row}>
            <div className={[s.text_left, styles.styImg].join(' ')}>
              <AccesRestreins numPrivilege={privilege.modifier_des_projets}>
                <PopupSmall
                  texte_ouverture={checkMot('ajouter_une_image')}
                  icone={<AiFillPicture />}
                  ajoutOverlay={styles.Overlay}
                >
                  <AjouterImageProjet
                    project_id={infoProjet.project_id}
                    ajouterImageProjet={(project_id, image) =>
                      dispatch(actions.reqAjouterImageProjet(project_id, image))
                    }
                  />
                </PopupSmall>
              </AccesRestreins>
            </div>

            <div className={s.text_left}>
              <AccesRestreins numPrivilege={privilege.modifier_des_projets}>
                <Bouton
                  cliquer={() => setShowModify(true)}
                  ajoutClass={styles.bts}
                >
                  <AiFillEdit /> {checkMot('modifier')}
                </Bouton>
              </AccesRestreins>
            </div>
            <div className={s.text_left}>
              <AccesRestreins numPrivilege={privilege.supprimer_des_projets}>
                <AttenteRequete request_type={requestType.supprimer_un_projet}>
                  <Bouton
                    cliquer={() =>
                      confirmeOnClick(
                        'Voulez vous vraiment supprimer ce utilisateur ?',
                        () => reqSupprimer(projectId)
                      )
                    }
                    ajoutClass={styles.bts}
                  >
                    <AiFillDelete /> {checkMot('supprimer')}
                  </Bouton>
                </AttenteRequete>
              </AccesRestreins>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  return (
    <div className={styles.ConteneurInfo}>
      <div className={[s.card_header, styles.hedes].join(' ')}>
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 16 16"
          className="bi bi-info-circle-fill"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
          />
        </svg>
        {checkMot('projet_id')}: {projectId}
      </div>
      <div className={s.container}>
        {showModify ? renderModifyForm() : renderProfile()}
      </div>
    </div>
  );
};

export default ProfilProjet;
